// src/registerServiceWorker.js

import { register } from 'register-service-worker'

import updateManager from '@/platform/pwa/updateManager'
import eventBus from '@/platform/core/eventBus'
import logger from '@/platform/core/logger'

console.log(
  '[PWA DEBUG] registerServiceWorker.js loaded',
  {
    NODE_ENV: process.env.NODE_ENV,
    BASE_URL: process.env.BASE_URL,
    hasServiceWorker:
      typeof navigator !== 'undefined' &&
      'serviceWorker' in navigator
  }
)

if (
  process.env.NODE_ENV ===
  'production'
) {
  /*
   * Register this before the service worker changes
   * controller so UpdateManager can reload the app
   * exactly once after activation.
   */
  updateManager.watchControllerChange()


  register(
    `${process.env.BASE_URL}service-worker.js`,
    {
      ready(registration) {
        logger.info(
          'Service worker is active and ready.'
        )

        updateManager.setRegistration(
          registration
        )

        eventBus.emit(
          'platform.serviceWorker.ready',
          {
            registration,
            timestamp:
              new Date().toISOString()
          }
        )
      },


      registered(registration) {
        logger.info(
          'Service worker registered successfully.'
        )

        updateManager.setRegistration(
          registration
        )

        eventBus.emit(
          'platform.serviceWorker.registered',
          {
            registration,
            timestamp:
              new Date().toISOString()
          }
        )


        /*
         * Check periodically while the application
         * remains open.
         *
         * This does NOT reload the application.
         * It only asks the browser whether a newer
         * service worker exists.
         */
        window.setInterval(
          () => {
            updateManager
              .checkForUpdate()
              .catch(error => {
                logger.warn(
                  'Periodic service worker update check failed.',
                  {
                    error
                  }
                )
              })
          },

          60 * 60 * 1000
        )
      },


      cached() {
        logger.info(
          'Application shell cached for offline use.'
        )

        eventBus.emit(
          'platform.serviceWorker.cached',
          {
            timestamp:
              new Date().toISOString()
          }
        )
      },


      updatefound() {
        logger.info(
          'New service worker version found.'
        )

        eventBus.emit(
          'platform.serviceWorker.updateFound',
          {
            timestamp:
              new Date().toISOString()
          }
        )
      },


      updated(registration) {
        logger.info(
          'New application version downloaded and waiting.'
        )

        updateManager.setRegistration(
          registration
        )

        if (
          registration?.waiting
        ) {
          updateManager.setWaitingWorker(
            registration.waiting,
            registration
          )
        }

        eventBus.emit(
          'platform.serviceWorker.updated',
          {
            registration,
            timestamp:
              new Date().toISOString()
          }
        )
      },


      offline() {
        logger.warn(
          'Application is running without a network connection.'
        )

        eventBus.emit(
          'platform.serviceWorker.offline',
          {
            timestamp:
              new Date().toISOString()
          }
        )
      },


      error(error) {
        logger.error(
          'Service worker registration failed.',
          {
            error
          }
        )

        eventBus.emit(
          'platform.serviceWorker.error',
          {
            error,
            timestamp:
              new Date().toISOString()
          }
        )
      }
    }
  )
}